import { FC, PropsWithChildren } from 'react';

import { TAdBannerMicrofrontendParameters } from 'shared/types/adBannerMicrofrontend';

interface IAdBannerPlaceholderProps {
  sizes: TAdBannerMicrofrontendParameters['sizes'];
  testId: string;
}

/**
 * Резервирует место под баннер, пока реклама грузится — иначе контент прыгает (CLS).
 */
export const AdBannerPlaceholder: FC<PropsWithChildren<IAdBannerPlaceholderProps>> = ({ children, sizes, testId }) => {
  return (
    <div data-testid={testId} style={{ height: sizes.height, minHeight: sizes.height, width: sizes.width }}>
      {children}
    </div>
  );
};
